// extracted by mini-css-extract-plugin
export var navContainer = "header-module--nav-container--1SoCU";
export var nav = "header-module--nav--106zH";
export var siteNav = "header-module--site-nav--12dxj";
export var mobnavcontainer = "header-module--mobnavcontainer--1RHLk";
export var mobnavbutton = "header-module--mobnavbutton--3aLAj";
export var mobnav = "header-module--mobnav--3w3HT";
export var mobtitle = "header-module--mobtitle--1thLa";
export var mobiletoggle = "header-module--mobiletoggle--1BD5m";
export var mobilelink = "header-module--mobilelink--2uIkj";